import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { JwtService } from '../services/jwt.service';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const jwtService = inject(JwtService);
  const token = jwtService.getAPIToken();
  if (token) {
    const cloned = req.clone({
      setHeaders: {
        authorization: `Bearer ${token}`
      },
    });
    req = cloned;
  }
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
     // if ([401, 403].includes(error.status)) {
      //  jwtService.logout();
      //}
      return throwError(() => error);
    })
  );
};
